const messageKeys = [
  'ALL_REWARDS_CLAIMED',
  'EQUIPMENT_CHANGE',
  'GOT_GAME_STATE',
  'HERO_CYCLED',
  'HERO_LEVEL_UP',
  'HERO_UNLOCK_INITIATED',
  'HERO_UNLOCKED',
  'ILLEGAL_GAME_STATE_UPDATE',
  'ITEM_REWARD_CLAIMED',
  'ITEM_SELECTED',
  'LOADOUT_UPDATED',
  'NO_INVENTORY_SPACE',
  'SHOW_MIRACLE_DYE_DIALOG',
  'TEAM_CHANGE',
  'XP_BOOST_USED',
];

const messages: Record<GameStateStoreMessage, GameStateStoreMessage> = Object.fromEntries(
  messageKeys.map((k) => [k, k])
) as Record<GameStateStoreMessage, GameStateStoreMessage>;
export default messages;

export type GameStateStoreMessage = (typeof messageKeys)[number];
